import { ajaxCall } from './ajax';
import { superModal, successModal, errorModal, confirmModal, formModal, infoModal, contentModal, courseConfirmModal } from './modal';
import PerfectScrollbar from 'perfect-scrollbar';
import Player from '@vimeo/player';
import "./starRating";

window.scrollPosition = 0;
window.redirects = false;
window.vimeoPlayers = new Array();

window.ajaxCall = ajaxCall;

window.$ = $;

function formatMoney(n, c, d, t) {
    var c = isNaN((c = Math.abs(c))) ? 0 : c,
        d = d == undefined ? "" : d,
        t = t == undefined ? " " : t,
        s = n < 0 ? "-" : "",
        i = String(parseInt((n = Math.abs(Number(n) || 0).toFixed(c)))),
        j = (j = i.length) > 3 ? j % 3 : 0;

    return (
        s +
        (j ? i.substr(0, j) + t : "") +
        i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t) +
        (c
            ? d +
            Math.abs(n - i)
                .toFixed(c)
                .slice(2)
            : "")
    );
}

function redirectFromLocalStorage() {
    let url = window.localStorage.getItem('redirect-to');
    window.localStorage.removeItem('redirect-to');
    if (url !== null)
        window.location.href = url;
}

function openNewsletterModal() {
    if ($('.newsletter-mail-address').length)
        $('#newsletter-modal #email').val($('.newsletter-mail-address').val())
    if ($('.logout').length)
        $('#newsletter-modal #email').val($('.logout').data('mail'))
    $('#newsletter-modal').modal();
}

$(document).ready(function () {
    clickHandlers();
    initScrollHandlers();
    initLayout();
    initSliders();
    initUi();
    uiEvents();
    initDateFormatter();
    if ($('.single-fejezet').length)
        initProgress();
    checkLocalStorage();
    initRedirects();
    vimeoInit();
    progressReportInit();
    formatH5P();
    video_modal();
    vaccine_modal();
    search_modal();
    search_setup();

    // Select the target node.
    let target = document.getElementsByClassName('h5p-iframe')[0]

    let fullscreen = false;
    // Create an observer instance.
    if (typeof target == "object") {

        let observer = new MutationObserver(function (mutations) {
            let $h5p = $(".h5p-iframe")

            $h5p.contents().find(".h5p-interactive-book-chapter.h5p-column").each(function () {
                let $right = $(this).find(".h5p-controls-right")
                let $vid = $(this)

                if ($right.length == 0 || $right.html().includes('open-full') && $right.html().includes('close-full')) {
                    return
                }
                if (!$right.html().includes('open-full')) {
                    $right.append('<div role="button" tabindex="0" class="h5p-control h5p-fullscreen open-full" aria-label="Fullscreen"></div>')
                }
                if (!$right.html().includes('close-full')) {
                    $right.append('<div role="button" tabindex="0" class="h5p-control h5p-fullscreen h5p-exit close-full" aria-label="Exit Fullscreen" style="z-index: 100001;"></div>')
                }
                let $open_full = $right.find(".open-full")
                let $close_full = $right.find(".close-full")
                $close_full.hide()

                $open_full.on("click", function () {

                    $close_full.show();
                    $open_full.hide();

                    let $vidframe = $vid.find(".h5p-column-content.h5p-interactive-video")

                    if ($vidframe[0].requestFullscreen) {
                        $vidframe[0].requestFullscreen();
                    } else if ($vid.webkitRequestFullscreen) { /* Safari */
                        $vidframe[0].webkitRequestFullscreen();
                    } else if ($vid.msRequestFullscreen) { /* IE11 */
                        $vidframe[0].msRequestFullscreen();
                    }
                    fullscreen = true

                    //controls placing
                    let $c4 = $vid.find(".h5p-controls")
                    $c4.css({ "margin-top": "-40px", "z-index": "100001" })
                    let $c5 = $c4.find("*")
                    $c5.css({ "z-index": "100002" })
                    let $slider = $vid.find(".ui-slider.ui-corner-all.ui-slider-horizontal.ui-widget.ui-widget-content")
                    $slider.css({ "z-index": "100003" })

                    //exit fullscreen mode button
                    $close_full.on("click", function () {
                        if (document.exitFullscreen) {
                            document.exitFullscreen();
                        } else if (document.msExitFullscreen) {
                            document.msExitFullscreen();
                        } else if (document.mozCancelFullScreen) {
                            document.mozCancelFullScreen();
                        } else if (document.webkitExitFullscreen) {
                            document.webkitExitFullscreen();
                        }
                        $close_full.hide();
                        $open_full.show();
                        $c4.css({ "margin-top": "0px", "z-index": "100000" })
                        $c5.css({ "z-index": "100001" })
                        $slider.css({ "z-index": "100002" })
                        fullscreen = false
                    })

                    if (document.addEventListener) {
                        document.addEventListener('fullscreenchange', exitHandler, false);
                        document.addEventListener('mozfullscreenchange', exitHandler, false);
                        document.addEventListener('MSFullscreenChange', exitHandler, false);
                        document.addEventListener('webkitfullscreenchange', exitHandler, false);
                    }

                    function exitHandler() {
                        if (!document.webkitIsFullScreen && !document.mozFullScreen && !document.msFullscreenElement) {
                            $close_full.hide();
                            $open_full.show();
                            $c4.css({ "margin-top": "0px", "z-index": "100000" })
                            $c5.css({ "z-index": "100001" })
                            $slider.css({ "z-index": "100002" })
                            fullscreen = false
                        }
                    }

                    var fadeTimer
                    var fadeAfterInterval = 2000
                    var $toFade = $c4

                    if (fullscreen) {
                        $vid.css('pointer-events', 'none');
                    }

                    $vid.on("mousemove", () => {
                        $vid.css('pointer-events', 'auto');
                        $toFade.fadeIn(0, () => { })
                        clearTimeout(fadeTimer)
                        fadeTimer = setTimeout(doneMoving, fadeAfterInterval)
                    })

                    function doneMoving() {
                        if (fullscreen) {
                            $vid.css('pointer-events', 'none');
                            $toFade.fadeOut(0, () => { })
                        }
                    }
                })
            })
        });

        // Pass in the target node, as well as the observer options.
        observer.observe(target, {
            attributes: true,
            childList: true,
            characterData: true
        });


    }

});

$(window).resize(function () {
    initLayout();
})

function search_setup() {
    var typingTimer
    var doneTypingInterval = 200
    var $input = $('#search-modal input')

    $input.on('keyup', function () {
        clearTimeout(typingTimer)
        typingTimer = setTimeout(doneTyping, doneTypingInterval)
    })

    $input.on('keydown', function () {
        clearTimeout(typingTimer)
    })

    async function doneTyping() {
        let res = await search($input.val())
        $(".search-tags").html(res)
    }
}

async function search(expr) {
    let fd = new FormData();
    fd.append('search', expr)
    const result = await $.ajax({
        url: "/api/search",
        type: 'POST',
        data: fd,
        cache: false,
        processData: false,
        contentType: false,
    })
    return result
}

function search_modal() {
    if ($('.search').length) {
        $('.search').on('click', async function () {
            $("#search-modal").modal('show')
            $('#search-modal input').val("")
            let res = await search("")
            $(".search-tags").html(res)
        })
    }
}

var welcome_info_url = ""

function vaccine_modal() {
    if ($(".vaccine-info").length) {
        $('.vaccine-info a').click(function (e) {
            e.preventDefault();
            $('#vaccine-modal').modal('show');
        });
    }
}

function video_modal() {
    if ($(".video.info").length) {
        $('.video a').click(function (e) {
            e.preventDefault();
            welcome_info_url = $("#video-modal").attr('data')
            $("#video-modal").find("iframe").attr('src', welcome_info_url)
            setTimeout(function() {
                $('#video-modal').modal('show');
            }, 1000);
        });

        $('#video-modal').on('hide.bs.modal', function () {
            $(this).find('iframe').attr('src', "#");
        })

        if ($("#video-modal").attr("show-data") == "true") {
            welcome_info_url = $("#video-modal").attr('data')
            $("#video-modal").find("iframe").attr('src', welcome_info_url)
            $('#video-modal').modal('show');
        }
    }
}

$("iframe").contents().find('.h5p-interactive-book-status-button').on("click", function () {
    $("iframe iframe").attr("src", "#")
})

function formatH5P() {
    $("iframe").on("load", function () {   

        $(this).contents().find("head").append('<style id="hidden_video-inline-css-inside" type="text/css">' + $('#hidden_video-inline-css').html() + '</style>');

        if ($(this).contents().find('.h5p-interactive-book-status-arrow').length) {
            $(this).contents().find('.h5p-interactive-book-status-arrow').slice(0, 3).hide()
        }
        if ($(this).contents().find('.h5p-interactive-book-status-progress').length) {
            $(this).contents().find('.h5p-interactive-book-status-progress').slice(0, 1).hide()
        }
        if ($(this).contents().find('.h5p-interactive-book-status-chapter .title').length) {
            $(this).contents().find('.h5p-interactive-book-status-chapter .title').slice(1, 2).hide()
        }
        if ($(this).contents().find('.h5p-actions').length) {
            $(this).contents().find('.h5p-actions').remove()
            $(this).contents().find(".h5p-content.h5p-initialized.h5p-frame.using-mouse").append('<div>&nbsp</div>')
        }
        if ($(this).contents().find('.h5p-interactive-book-enter-fullscreen').length) {
            $(this).contents().find('.h5p-interactive-book-enter-fullscreen').remove()
        }
        let that = this;

        let inner_iframe_parents = $(this).contents().find('.h5p-column-content');
        $(inner_iframe_parents).each(function(index, element){
            let fullscreen_iframe = $(element).find('iframe').get(0);
            if(fullscreen_iframe){
                if(!$(element).find('.vimeo-fullscreen-custom-button').length){
                    $(element).append(`<div class='vimeo-fullscreen-custom-button' style='z-index: 4500;position: absolute;right: 3%; top:5px; width: 40px; height: 40px; background-color: black; border-radius: 8px; display: flex; justify-content: center; align-items: center'>
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M2 7V2H7" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/> <path d="M22 7V2H17" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/> <path d="M7 22L2 22L2 17" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/> <path d="M17 22L22 22L22 17" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/> </svg>
                    </div>`);
                    var viewFullScreens = that.contentWindow.document.getElementsByClassName("vimeo-fullscreen-custom-button");
                    for(let value of viewFullScreens){
                        value.addEventListener("click", function() {
                            if (fullscreen_iframe.mozRequestFullScreen) {
                                fullscreen_iframe.mozRequestFullScreen().catch((err) => {
                                    errorModal("A böngésző nem támogatja a teljes képernyős módot! A teljes kijelzős módhoz kérjük próbáljon más böngészőt.");
                                  });
                            } else if (fullscreen_iframe.requestFullscreen) {
                                fullscreen_iframe.requestFullscreen();
                            } else if (fullscreen_iframe.msRequestFullscreen) {
                                fullscreen_iframe.msRequestFullscreen();
                            } else if (fullscreen_iframe.webkitRequestFullScreen) {
                                fullscreen_iframe.webkitRequestFullScreen();
                            }

                            /*                            } if (fullscreen_iframe.mozRequestFullScreen) {
                                fullscreen_iframe.mozRequestFullScreen().catch((err) => {
                                    alert(
                                      `Error attempting to enable fullscreen mode: ${err.message} (${err.name})`,
                                    );
                                  });*/
                        })
                    }
                }
            }
        })

        $(this).contents().find('.h5p-interactive-book-status-button').on("click", function () {
            $(that).contents().find('.h5p-interactive-book-chapter iframe').each(function(index, element) {
                if($(element).prop('src').includes('player.vimeo')){
                    element.src = element.src;
                    $(element).prop("mozallowfullscreen", "mozallowfullscreen");
                    $(element).prop("webkitallowfullscreen", "webkitallowfullscreen");
                    $(element).prop("allowfullscreen", "allowfullscreen");

                    
                }
            });
        })

        //Oldalsávban léptetők
        $(this).contents().find('.h5p-interactive-book-navigation-chapter').on("click", function () {
            window.testVar = $(that).contents().find('.h5p-interactive-book-chapter iframe');
            $(that).contents().find('.h5p-interactive-book-chapter iframe').each(function(index, element) {
                if($(element).prop('src').includes('player.vimeo')){
                    element.src = element.src;
                }
            });
        })

        $(this).contents().find("iframe").on("load", function () {
            console.log("inside iframe loaded");
            loadQuestionSetLabel(that);
        })

        loadQuestionSetLabel(that);

    })


    // let $html = $(".chapterFinishMessage")
    // $(".chapterFinishMessage").remove()
    // $("main").append($html)
    // if ($(".chapterFinishMessage")) {

    // }
}

function loadQuestionSetLabel(iframe) {
    let that = iframe;
    if($(that).contents().find('.questionset').length) {
        $(that).contents().find('.questionset').each(function(index, element) {
            $(element).find('.h5p-question .h5p-question-next').css({
                padding: '0.5em 1.25em',
                width: 'unset',
                float: 'right'
            })
            $(element).find('.h5p-question .h5p-question-prev').css({
                padding: '0.5em 1.25em',
                width: 'unset',
                float: 'right'
            })
            $(element).find('.h5p-question .h5p-question-next').html("Következő kérdés")
            $(element).find('.h5p-question .h5p-question-prev').html("Előző kérdés")
            $(element).find('.h5p-question .h5p-question-check-answer').html("Ellenőrzés")
            $(element).find('.h5p-question .h5p-question-next').removeClass("h5p-question-next")
            $(element).find('.h5p-question .h5p-question-prev').removeClass("h5p-question-prev")
        });
    }
}

function b64DecodeUnicode(str) {
    return decodeURIComponent(Array.prototype.map.call(atob(str), function (c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
    }).join(''))
}


function clickHandlers() {
    $(document).on("click", ".rate-button", function () {
        $('#rating-modal #course-id').val($(this).data('course-id'));
        $('#rating-modal').modal("show");
    })

    $('.invite-modal').click(function () {
        $('#invite-modal').modal('show');
        $('.overlay').removeClass('show');
    });

    // $('.pp-card .title').on('click', function() {
    //     $(this).find('i').toggleClass('fa-chevron-down');
    //     $(this).find('i').toggleClass('fa-chevron-up');
    // });

    $('.video-popup').click(function () {
        let container = $('#homework-modal .vimeo-video-in-modal');
        let options = {
            url: $(this).data('url'),
            autopause: true
        };
        let player = new Player(container, options);
        if ($(this).data('start')) {
            player.setCurrentTime($(this).data('start'));
        }
        if ($(this).data('end')) {
            let end = parseInt($(this).data('end'));
            let autohide = $(this).data('autohide');
            let interval = window.setInterval(async function () {
                let time = await player.getCurrentTime();
                if (time > end) {
                    player.pause();
                    clearInterval(interval);
                    if (autohide)
                        $('#homework-modal').modal('hide');
                }
            }, 500);
        }
        window.vimeoPlayers.push(player);
        
        setTimeout(function() {
            $('#homework-modal').modal('show');
            player.play();
        }, 1000);

        $('#homework-modal').on('hide.bs.modal', function () {
            player.destroy();
        });
    });

    $('.homework button.success').click(function () {
        $(this).addClass('load');
        $(this).addClass('disabled');
        $(this).prop('disabled', true);
        let data = new FormData();
        data.append("homework_id", $(this).data('id'));
        ajaxCall('/homeworkDone', 'POST', data);
    })

    $('header .fa-bars, .loggedInMenuButton').click(function (e) {
        e.stopPropagation();
        $('header').toggleClass('open');
        $('.overlay').toggleClass('show');
    });

    $('.overlay').click(function () {
        $('header.open').removeClass('open');
        $(this).removeClass('show');
    });

    //legcy
    $('.video a').click(function (e) {
        if (!$(this).hasClass('tag')) {
            e.preventDefault();
            let videoId = $(this).parents('.video').data('id');
            $("#video-modal").find("iframe").attr('src', `https://www.youtube-nocookie.com/embed/${videoId}?autoplay=1`)
            $('#video-modal').modal('show');
        }
    });

    $('.searchForm').submit(function (e) {
        e.preventDefault();
        window.location.href = `/?s=${$(this).find('#searchTerm').val()}`;
    });

    $(".searchTogle").click(function () {
        $('#searchModal').modal('show');
    });

    $('#video-modal').on('hide.bs.modal', function () {
        $(this).find('iframe').attr('src', "");
    })

    $('.moreModal').click(function () {
        contentModal($(this).data('title'), b64DecodeUnicode($(this).data('content')));
    });

    $('.course-modal').click(function () {
        initCourseModalTexts($(this));
        $('#course-modal').modal();
    });

    $(document).on('click', '.btn-my-info-valid', function () {
        $('#super-modal').modal('hide');
        $('#applicationForm').submit();
    });

    $(document).on('click', '.demo-menu-point', function (event) {
        successModal($(event.target).data('text'), false, "Információ");
    });

    $(document).on('click', function (e) {
        var openedThings = $('.open').length;
        if ((!$(e.target).hasClass('open') && $(e.target).parents('.open').length == 0) && openedThings != 0)
            $('.open').removeClass('open');
    })

    $('header a[href^="#"]').click(function (e) {
        e.preventDefault();
    });

    $(document).on('click', '.premium-banner', function () {
        let url = $(this).data('url');
        ajaxCall(url, 'POST', {});
    });

    $(document).on('click', '.teacher', function () {
        $('#teacherModal .image').css('background-image', `url(${$(this).data('image')})`);
        $('#teacherModal .name b').html($(this).data('name'));
        $('#teacherModal .position').html($(this).data('pozicio'));
        $('#teacherModal .aboutme .content').html($(this).data('about'));
        $('#teacherModal').modal('show');
    });
    $('header .lower nav > ul > li').click(function (e) {
        if ($(e.target).parents('li.children ul').length == 0) {
            if ($(this).hasClass('open')) {
                $(this).removeClass('open');
            } else {
                $('header .lower nav > ul > li.open').removeClass('open');
                $(this).addClass('open');
            }
        }
    });

    $('.overlay').click(function () {
        $('.in').removeClass('in');
        $('body').removeClass('overlay-in');
    });

    $('#newsletter').change(function () {
        if (this.checked) {
            $('.newsletter-more-info').show();
        }
        else {
            $('.newsletter-more-info').hide();
        }
    });

    $('.menu-toggle').click(function () {
        $('body').toggleClass('overlay-in');
        $('.main-menu').toggleClass('in');
    });

    $('.multitab .tabNav span').click(function () {
        $(this).parents('.multitab').find('.active').removeClass('active');
        $(this).addClass('active');
        let id = $(this).data('tab');
        $(this).parents('.multitab').find(`#tab${id}`).addClass('active');
        $(this).parents('.multitab').find(`#tabBg${id}`).addClass('active');
    });

    $('.upper .logout').click(function (e) {
        e.preventDefault();
        let url = $(this).attr('href');
        ajaxCall(url, 'POST', {});
    });

    $('form').submit(function (e) {
        e.preventDefault();
        $(this).find('button, .button').each(function () {
            if (!$(this).hasClass('btn-close'))
                $(this).addClass('load');
        })
        let url = $(this).attr('action');
        let data = new FormData($(this)[0]);
        $.each($(this).find("input[type=checkbox]"), function (key, val) {
            if (!$(val).attr('name').includes('[]'))
                data.set($(val).attr('name'), ($(this).prop('checked')) ? $(this).prop('value') : "")
        });
        ajaxCall(url, 'POST', data);
    });

    $('.edit-profile').click(function () {
        $('#profile-modal').modal('show');
    });

    $(document).on('click', '.delete-dog', function () {
        let dog_id = $(this).data('dog');
        confirmModal("Biztos törölni szeretné?", "Ez a folyamat nem fordítható vissza.", {
            'run': function (params) {
                $('#super-modal .btn-confirm').addClass("disabled");
                $.post({
                    url: params.url,
                    data: { "dog_id": params.dog_id },
                    complete: function (response) {
                        //window.location.reload();
                    },
                });
            },
            'url': '/kutya/torles',
            'dog_id': dog_id,
        });
    });

    $('.add-dog-card').click(function () {
        $('#dog-modal-form').attr('action', '/kutya/hozzaadas');
        $('#dog-modal-form .title').val("Kutya hozzáadása");
        $('#dog-modal-form input[name=dog_id]').val("");
        $('#dog-modal-form input[name=name]').val("");
        $('#dog-modal-form input[name=fajta]').val("");
        $('#dog-modal-form input[name=szuletesi_ido]').val("");
        $('#dog-modal-form select[name=kutya_merete]').val("ns");
        $('#dog-modal-form select[name=nem]').val("ns");
        $('#dog-modal-form select[name=oltott]').val("ns");
        $('#dog-modal #imageResult').css("background-image", "url()");
        $('#dog-modal').modal('show');
    });

    $('.edit-dog-card').click(function () {
        $('#dog-modal-form').attr('action', '/kutya/modositas');
        $('#dog-modal-form .title').val("Kutya szerkesztése");
        $('#dog-modal-form input[name=dog_id]').val($(this).data('dog_id'));
        $('#dog-modal-form input[name=name]').val($(this).data('name'));
        $('#dog-modal-form input[name=fajta]').val($(this).data('fajta'));
        $('#dog-modal-form input[name=szuletesi_ido]').val($(this).data('szuletesi_ido'));
        $('#dog-modal-form select[name=kutya_merete]').val($(this).data('kutya_merete'));
        $('#dog-modal-form select[name=nem]').val($(this).data('nem'));
        $('#dog-modal-form select[name=oltott]').val($(this).data('oltott'));
        $('#dog-modal #imageResult').css("background-image", "url(" + $(this).data('kep') + ")");
        $('#dog-modal').modal('show');
    })

    $('.show-complete-info').click(function () {
        let school = $(this).data('school');
        let dog = $(this).data('dog');
        let time = $(this).data('time');
        let name = $(this).data('name');
        contentModal("Tanfolyam információk", `
        <div class="row">
        <div class="col-6 pt-3">
        <div>Tanfolyam neve:</div>
        <div>${name}</div>
        </div>
        <div class="col-6 pt-3">
        <div>Tanfolyam ideje:</div>
        <div>${time}</div>
        </div>
        <div class="col-6 pt-3">
        <div>Kutyaiskola:</div>
        <div>${school}</div>
        </div>
        <div class="col-6 pt-3">
        <div>Kutya, amivel részt vett:</div>
        <div>${dog}</div>
        </div>
        </div>`);
    });

    $('.galeria-comp').click(function () {
        let id = $(this).data('id');
        window.location = `/tanfolyam-galeria?course=${id}`;
    });

    $('.pay-it-all').click(function () {
        let id = $(this).data('payment');
        let url = "/kifizetes";
        let data = new FormData();
        data.append('payment_id', id);
        ajaxCall(url, "POST", data);
    });

    $('.homework-subtasks input[type="checkbox"]').on('click', function () {
        //Megnézni az összes checkbox értékét
        let selected_indexes = []; 
        let all_is_selected = true;
        $('.homework-subtasks input[type="checkbox"]').each(function(index, element) {
            if($(element).prop('checked')) {
                selected_indexes.push($(element).val());
            }else{
                all_is_selected = false;
            }
        })

        if(all_is_selected) {
            $('.homework-done-button').removeClass('disabled');
            $('.homework-done-button').prop('disabled', false);
        }else{
            $('.homework-done-button').addClass('disabled');
            $('.homework-done-button').prop('disabled', true);
        }
        
        let id = $('.homework-subtasks').data('homework-id');
        let url = "/sync-subtasks";

        let data = new FormData();
        data.append('homework_id', id);
        data.append('selected_indexes', selected_indexes.join(','));
        
        ajaxCall(url, "POST", data);
    });

    $('#super-modal').on('hidden.bs.modal', function () {
        $(document).off('click', '#super-modal .btn-confirm');
    });

    $('.filter .search').click(function () {
        let filter = $(this).parents('.filter');
        let params = {};
        filter.find('select').each(function () {
            if ($(this).val() != 'ns')
                params[this.id] = $(this).val();
        });
        window.location.href = `/tanfolyamok?${$.param(params)}`;
    });

    $('.tukorpoint-buy').click(function () {
        $('#tp-modal').modal('show');
    });

    $('.get-my-billing').click(function (e) {
        event.preventDefault();
        let id = $(event.target).data("id");
        let url = "/user-billing";
        infoModal('Számláim megtekintése', url, {});
    });

    $(document).on('click', '.tananyag-lecke-stepper', function (e) {
        let sorted= $(e.target).data('sorted');
        $(`.tananyag-leckek .nav-link[data-sorted=${sorted}]`).trigger('click');
    })

    $('.newsletter-modal-opener').click(function () {
        openNewsletterModal();
    })

    $('#newsletter-modal .btn-confirm').click(function () {
        $('#newsletter-modal form').submit();
    })

    $('select[name=fizetes_tipusa]').on('selectmenuchange', function () {
        if ($(this).val() == "tukorpont") {
            let cyclosUser = $(this).parents('form').data('cyclosuser') != undefined ? $(this).parents('form').data('cyclosuser') : "";
            let cyclosPass = $(this).parents('form').data('cyclospass') != undefined ? $(this).parents('form').data('cyclospass') : "";
            $(this).parent().after(`<div class="inputGroup col-12 col-md-6 mt-3"><label>Tükörpont rendszer jelszó jelszó</label><input type="password" type="text" autocomplete="off" name="cyclos_pass" value="${cyclosPass}"><div class="errorText"></div></div>`)
            $(this).parent().after(`<div class="inputGroup col-12 col-md-6 mt-3"><label>Tükörpont kártya sorszáma</label><input type="text" autocomplete="off"  name="cyclos_id" value="${cyclosUser}"><div class="errorText"></div></div>`)
        } else {
            $('input[name=cyclos_id]').parent().remove();
            $('input[name=cyclos_pass]').parent().remove();
        }
    });

    $('.vote-button-radio').click(function (e) {
        e.preventDefault();
        $('.choose-question').remove();

        let radio = $(this).parents('.vote-form').find('input[type="radio"]:checked').parent().parent().find('.custom-progress');
        let radioAll = $(this).parents('.vote-form').find('input[type="radio"]').parent().parent().find('.custom-progress');

        if (radio.length > 0) {
            incrementOption(radio, 'value', 1);
            incrementOption(radioAll, 'max', 1);

            let post_id = $(this).parent().siblings('input[name="post_id"]').val();
            localStorage.setItem(post_id, "ya");

            $(this).parents('form').find('.custom-progress').show();
            $(this).parent().hide();

            $(this).parents('form').submit();
        }
        else {
            $(this).parents('form').find('.vote-block-question').after('<div class="choose-question">Szavazat beküldéséhez válassz ki egyet!</div>');
        }


    });
    $('.vote-button-check').click(function (e) {
        e.preventDefault();

        let checkboxes = $(this).parents('.vote-form').find('input[type="checkbox"]:checked').parent().parent().find('.custom-progress');
        let checkboxesAll = $(this).parents('.vote-form').find('input[type="checkbox"]').parent().parent().find('.custom-progress');

        if (checkboxes.length > 0) {

        }

        let checkboxCount = incrementOption(checkboxes, 'value', 1);
        incrementOption(checkboxesAll, 'max', checkboxCount);

        let post_id = $(this).parent().siblings('input[name="post_id"]').val();
        localStorage.setItem(post_id, "ya");

        $(this).parents('form').find('.custom-progress').show();
        $(this).parent().hide();

        $(this).parents('form').submit();
    });
}

function checkLocalStorage() {
    let blocks = $('.vote-form input[name="post_id"]');
    blocks.each((key, value) => {
        let id = $(value).val();
        var isVoted = localStorage.getItem(id);
        if (isVoted == "ya") {
            $(value).siblings('.vote-button-wrapper').hide();
            $(value).parents('form').find('input[type="checkbox"]').attr("disabled", "disabled");
            $(value).parents('form').find('input[type="radio"]').attr("disabled", "disabled");
        }
        else {
            $(value).parents('form').find('.custom-progress').hide();
        }
    })
}

function initLayout() {
    if (!$('body').hasClass('no-header'))
        $('body').css('padding-top', $('header').outerHeight());
    $('footer').css('display', 'unset');
    $('body').css('padding-bottom', $('footer').outerHeight());
    requiredFields.forEach(element => {
        $(`[name = '${element}']`).parents('.inputGroup').addClass('required');
    });
    $('#tp-modal #amount').on('keyup', function () {
        let parent = $(this).parents('form');
        parent.find('.price').html(`Ár: ${formatMoney($(this).val() * parent.data('arfolyam'))}Ft`);
    });
}

function initSliders() {
    if ($('.home-slider').length) {
        let params = {
            loop: true,
            nav: true,
            lazyLoad: true,
            lazyLoadEager: 1,
            autoplay: true,
            items: 1,
            dots: false
        };
        $('.home-slider').owlCarousel(params);
    }
    if ($('.teacherSlider').length) {
        let params = {
            loop: true,
            nav: false,
            lazyLoad: true,
            lazyLoadEager: 1,
            autoplay: true,
            dots: false,
            margin: 20,
            autoplayHoverPause: true,
            responsive: {
                0: {
                    items: 2
                },
                600: {
                    items: 3
                },
                900: {
                    items: 4
                },
                1200: {
                    items: 5
                }
            }
        };
        $('.teacherSlider').owlCarousel(params);
    }
    if ($('.photoSlider').length) {
        let params = {
            loop: true,
            nav: true,
            lazyLoad: true,
            lazyLoadEager: 1,
            autoplay: true,
            dots: false,
            responsive: {
                0: {
                    items: 1,
                    margin: 10
                },
                600: {
                    items: 3
                }
            }
        };
        $('.photoSlider').owlCarousel(params);
    }
    if ($('.reviewSlider').length) {
        let params = {
            loop: true,
            nav: true,
            items: 1,
            dots: false,
            autoplayHoverPause: true,
            autoHeight: true,
            responsive: {
                0: {
                    nav: false
                },
                800: {
                    nav: true
                }
            }
        };
        $('.reviewSlider').owlCarousel(params);
    }
    if ($('.servicesSlider').length) {
        let params = {
            loop: true,
            nav: false,
            lazyLoad: true,
            lazyLoadEager: 1,
            autoplay: true,
            dots: false,
            autoplayHoverPause: true,
            responsive: {
                0: {
                    items: 2,
                    margin: 20
                },
                600: {
                    items: 3
                },
                720: {
                    margin: 0
                },
                900: {
                    items: 4
                },
                1200: {
                    items: 5
                }
            }
        };
        $('.servicesSlider').owlCarousel(params);

    }
}

function getLoadingHtml() {
    return `<div class="text-center w-100 col-12 loadingSnippet"><i class="fas fa-spinner"></i></div>`;
}

function initUi() {
    let psContainers = document.querySelectorAll('.ps-container');
    psContainers.forEach(psContainer => {
        new PerfectScrollbar(psContainer);
    });

    $('[data-toggle="tooltip"]').tooltip({ boundary: 'window', offset: 10 });

    if (window.location.href.includes('#hirlevel')) {
        openNewsletterModal();
    }

    $('select').each(function () {
        let sel = "";
        if ($(this).find('.selected').length == 0)
            sel = "selected";
        $(this).prepend(`<option value="ns" ${sel}>Kérlek válassz!</option>`);
    })
    //$('select').selectmenu();

    inith5pVimeoIframe();
}

function uiEvents() {
    $('.courseFilter select').on('selectmenuchange', function (event, ui) {
        let url = new URL(window.location.href);
        url.searchParams.set($(this).data('param'), ui.item.value);
        if (ui.item.value == 'ns')
            url.searchParams.delete($(this).data('param'));
        window.history.pushState({}, "", url.href);
        $('.courses').html(getLoadingHtml());
        $.post(url.href).done(function (data) {
            $('.courses').html(data);
        })
    });
    $('.socialLogin').click(function () {
        if ($('input[name="redirect-to"]').val() != '')
            window.localStorage.setItem('redirect-to', $('input[name="redirect-to"]').val());
    });
    $('.modal').on('show.bs.modal', function () {
        $('html').css('overflow', 'hidden');
    });
    $('.modal').on('hide.bs.modal', function () {
        $('html').css('overflow', 'unset');
    });
}

function initDateFormatter() {
    $("input[name='szuletesi_ido']").on("keyup", function () {
        var date = this.value;
        if (window.event.keyCode == 8) { }
        else if (date.match(/^\d{4}$/) !== null) {
            this.value = date + '-';
        }
        else if (date.match(/^\d{4}\-\d{2}$/) !== null) {
            this.value = date + '-';
        }
        else if (date.match(/^\d{4}\-\d{2}\-\d{3}$/) !== null) {
            this.value = date.substring(0, date.length - 1);
        }
    });
}

function initScrollHandlers() {
    document.addEventListener('scroll', function () {
        if ($(window).scrollTop() > scrollPosition && $(window).scrollTop() > 50) {
            $('header').addClass('mini');
        } else {
            $('header').removeClass('mini');
        }
        scrollPosition = $(window).scrollTop();
    }, { passive: true })
}

function initCourseModalTexts(element) {
    $('#course-modal .course-name').text(element.closest('.eventListItem').find('.title').text());
    $('#course-modal .course-desc').text(element.closest('.eventListItem').find('.desc').text());
    $('#course-modal .course-date span').text(element.closest('.eventListItem').find('.date').text());
    $('#course-modal .course-place span').text(element.closest('.eventListItem').find('.place').text());
    $('#course-modal .course-price').text(element.closest('.eventListItem').find('.price').text());
    $('#course-modal .bg-image').css('background-image', `url(${element.parents('.eventListItem').find('.bg-image').data('fullsize')})`);
    $('#course-modal .btn-apply').attr('href', `/jelentkezes?course=${element.data('id')}`);
    $('#course-modal .btn-info').attr('href', `/tanfolyam/${element.data('slug')}`);
}

function courseAppendInfo() {
    $('#applicationForm label').each(function () {
        if ($(this).text() != "Kutya") {
            let selectVal = $(this).siblings('select').find('option:selected').text();
            let textAreaVal = $(this).siblings('textarea').val();
            if (selectVal || textAreaVal) {
                $('#super-modal .form-info').append(`
            <div class="col-5 mb-2">${$(this).text()}</div>
            <div class="col-7 bold-letter blue-letter">${selectVal || textAreaVal}</div>
            `);
            }
        }

    });
}

function initProgress() {
    $(".custom-progress").each(function () {
        $(this).html('');
        $(this).append(`
        <div class="lines">
            <span class="bg"></span>
            <span class="inner"></span>
        </div>
        <div class="data">
            <span class="current"></span> / 
            <span class="max">${$(this).data('max')}</span>
        </div>`);
        $(this).find('.bg').css('background-color', $(this).data('color'));
        $(this).find('.inner').css({
            "background-color": $(this).data('color')
        });
        $(this).find('.inner').animate({ width: `${(parseFloat($(this).data('value')) / parseFloat($(this).data('max'))) * 100}%` }, 1000);
        let i = 0;
        let parent = $(this);
        let counter = setInterval(function () {
            $(parent).find('.current').html(Math.ceil(i / 100 * $(parent).data('value')));
            i++;
            if (i == 100)
                clearInterval(counter);
        }, 10);
    });
}

function incrementOption(array, dataValue, incValue) {
    let tickedValue = 0;
    array.each((key, element) => {
        let count = $(element).data(dataValue);
        count += incValue;
        tickedValue++;
        $(element).data(dataValue, count);
    });
    return tickedValue;
}

function initRedirects() {
    if (window.localStorage.getItem('redirect-to') !== null)
        redirects = true;
    if ($('.automaticRedirect').length)
        redirectFromLocalStorage();
}

function vimeoInit() {
    let videoContainers = document.querySelectorAll('.vimeo-video');
    videoContainers.forEach(container => {
        let options = {
            url: container.dataset.url,
        };
        let player = new Player(container, options);

        player.on('play', function () {
            window.videoStarted = 1;
            updateProgress();
        })

        window.vimeoPlayers.push(player);

        // setInterval(function () {
        //     let posX = Math.floor(Math.random() * 80) + 1;
        //     let posY = Math.floor(Math.random() * 80) + 1;
        //     let overlay = $(`<small style="opacity:0.7; left: ${posX}%; top: ${posY}%" class="video-overlay position-absolute text-white">${$('body').data('user')}</small>`).appendTo(container);

        //     setTimeout(function () {
        //         $(overlay).remove();
        //     }, 1000);
        // }, 5000);
    });
}

//PROGRESS LOGGING - UGLY CODE WARNING!!! :(

window.currentState = 0;
window.videoStarted = false;
window.fileDownloaded = false;

function progressReportInit() {
    if ($('.h5p-container').length) {
        H5P.externalDispatcher.on('xAPI', function (event) {
            if (event.data.statement.verb.display['en-US'] == 'completed') {
                updateProgress();
            }
        });

        setInterval(function () {
            if (getH5PProgress() != window.currentState) {
                window.currentState = getH5PProgress();
                updateProgress();
            }
        }, 500);
    } else {
        window.currentState = 1;
    }

    if ($('.file-download').length == 0) {
        window.fileDownloaded = 1;
    } else {
        $('.file-download').click(function () {
            window.fileDownloaded = 1;
            updateProgress();
        })
    }

    if ($('.vimeo-video').length == 0) {
        window.videoStarted = 1;
    }

    if ($('.h5p-container').length) {
        updateProgress();
    }

}

function getH5PProgress() {
    if (window.currentState == 1)
        return 1;
    let current = 0
    let max = 1
    if ($('.h5p-interactive-book-status-progressbar-front')) {
        current = parseInt($(window.frames[0].frameElement.contentWindow.document.querySelector('.h5p-interactive-book-status-progressbar-front')).css('width'));
    }
    if ($('.h5p-interactive-book-status-progressbar-back')) {
        max = parseInt($(window.frames[0].frameElement.contentWindow.document.querySelector('.h5p-interactive-book-status-progressbar-back')).css('width'));
    }
    return current / max;
}

function logProgress() {
    $.post('/api/logProgress',
        {
            chapter: $('main').data('chapter'),
            percentage: getH5PProgress(),
            url: window.location.href,
        }, logSuccess
    )
}

function logSuccess(data, statusString, xhr) {
    if (data.replace(/\s+/g, "") != "") {
        try {
            let response = JSON.parse(data);
            if (response.action == "prepend") {
                $('.chapterFinishMessage').remove();
                $('main').append(response.html);
                $('html, body').animate({
                    scrollTop: 100000
                }, 1000); // for all browsers
            }
        } catch (e) {
            $('.chapterFinishMessage').remove();
        }
    }
}

function updateProgress() {
    if (getH5PProgress() == 1 && window.videoStarted == 1 && window.fileDownloaded == 1) {
        logProgress();
    } else if (getH5PProgress() < 1)
        logProgress();
}

window.getH5PProgress = getH5PProgress;
window.logProgress = logProgress;

window.inith5pVimeoIframe = inith5pVimeoIframe;

function inith5pVimeoIframe() {
    if ($('.h5p-container').length) {
        setTimeout(function () {
            let frames = window.frames[0].frameElement.contentWindow.document.querySelectorAll('.h5p-iframe-wrapper');
            frames.forEach(frame => {
                if ($(frame).attr('src').includes('vimeo')) {
                    let container = $(frame).parent().css(
                        {
                            position: 'relative',
                            width: '100%',
                            height: 0,
                            'padding-bottom': '54%'
                        }
                    );

                    $(frame).css({
                        position: 'absolute',
                        width: '100%',
                        height: '100%',
                        top: 0,
                        left: 0
                    });

                    $(frame).parents('.h5p-interactive-book-content').css({
                        'min-height': `${$(frame).outerHeight()}px`
                    })

                    // setInterval(function () {
                    //     let posX = Math.floor(Math.random() * 80) + 1;
                    //     let posY = Math.floor(Math.random() * 80) + 1;
                    //     let overlay = $(`<small style="opacity:0.7; left: ${posX}%; top: ${posY}%; position:absolute; color: #fff;">${$('body').data('user')}</small>`).appendTo(container);

                    //     setTimeout(function () {
                    //         $(overlay).remove();
                    //     }, 1000);
                    // }, 5000);
                }
            });
        }, 500);
    }
}

